/* Página atualizada e funcionando

Essa parte de layouts serve para chamar o código que está em pages, onde tudo é realmente montado.

*/

import SOC from "pages/Servicos/SOC";

export default function SOCPage() {
  return <SOC />;
}
